import { TrackingPageTypeWithoutId } from '@aboutyou/legacy-tracking-sdk'
import React, { FC } from 'react'

import DocumentHead from './components/DocumentHead'

import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import { WelcomePageContentFocus } from 'pages/Welcome/components/WelcomePageContentFocus/WelcomePageContentFocus'
// eslint-disable-next-line no-restricted-imports
import type { GetGenderedCardsResponse_CardSliders_Card } from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.types'

const WelcomePage: FC<{
  campaignCard?: GetGenderedCardsResponse_CardSliders_Card
}> = ({ campaignCard }) => {
  return (
    <div>
      <DocumentHead />
      <WelcomePageContentFocus campaignCard={campaignCard} />
    </div>
  )
}

const TrackedWelcomePage: FC<{
  campaignCard?: GetGenderedCardsResponse_CardSliders_Card
}> = ({ campaignCard }) => {
  const { path, search } = useTrackingPageUrl()

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.Welcome}
    >
      <WelcomePage campaignCard={campaignCard} />
    </PageTrackingContextProvider>
  )
}

export default TrackedWelcomePage
